/**
 * Leaf enum for high-intent offer tile display state.
 * Kept out of HighIntentOfferCard so tile components can share it
 * without the HotLeadTile ↔ HighIntentOfferCard cycle.
 */
export enum HighIntentOfferDisplayStatus {
  LOADING,
  SHOW,
  HIDE,
}
